exports.IDS = {
  // IMG_URL: "http://192.168.16.183:4327",
  IMG_URL: "https://pmroad.node.profcymadev.com:4325",
  // IMG_URL: "https://node.bhagvadhari.com",
  PAGE: 1,
  PERPAGE: 10,
  TOTALPAGES: 1,
  TOTAL: 1,
  ACTIVE: "Active",
  INACTIVE: "Inactive",
  SLICESTATUS: {
    Idle: "idle",
    Loading: "loading",
    Succeeded: "succeeded",
    Failed: "failed",
  },

  users: {
    admin: 1,
    builder: 2,
    customer: 3,
  },

  usersrole: {
    admin: "Admin",
    builder: "Builder",
    customer: "Customer",
  },

  legal_verification_status: {
    process: 1,
    approved: 2,
    rejected: 3,
  },
};
